export default __webpack_public_path__ + "static/media/5.75f96b5d.jpg";